
import {
    NgModule,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PortalModule } from '@angular/cdk/portal';

import { ButtonModule } from '../button';
import { DialogService } from './dialog.service';
import { ModalModule } from '../modal';
import { AlertComponent } from './alert/alert.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { PromptComponent } from './prompt/prompt.component';
import { PortalUtil } from '../util/portal';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        PortalModule,
        ModalModule,
    ],
    exports: [
        AlertComponent,
        ConfirmComponent,
    ],
    declarations: [
        AlertComponent,
        ConfirmComponent,
        PromptComponent,
    ],
    entryComponents: [
        AlertComponent,
        ConfirmComponent,
        PromptComponent,
    ],
    providers: [
        DialogService,
        PortalUtil,
    ]
})
export class DialogModule {
    public static forRoot() {
        return {
            ngModule: DialogModule,
            providers: [DialogService]
        };
    }
}

export { DialogService };
